module.exports = __webpack_public_path__ + "media/images/lb/886-4c67e4f5d5db6370c8aee439958a2868.svg";